'use client';

import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

export class RoomErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[RoomErrorBoundary]', error, info.componentStack);
  }

  private reload = () => {
    window.location.reload();
  };

  private leave = () => {
    const base = window.location.origin;
    window.location.href = base;
  };

  render() {
    if (this.state.error) {
      return (
        <div
          className="lk-room-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            background: 'var(--lk-bg, #111)',
            color: 'var(--lk-fg, #eee)',
          }}
        >
          <div style={{ maxWidth: 420, textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>
              Algo deu errado na reunião
            </h1>
            <p style={{ fontSize: '0.95rem', opacity: 0.85, marginBottom: '1.5rem' }}>
              A conexão de vídeo encontrou um erro inesperado. Você pode tentar recarregar ou sair
              e entrar novamente.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button type="button" className="lk-button" onClick={this.reload}>
                Recarregar
              </button>
              <button type="button" className="lk-button lk-button-secondary" onClick={this.leave}>
                Sair
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
